import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import ActivityFilters from '@nedoShared/modules/dashboard/activityFilters/ActivityFilters';
import ActivityCards from '@nedoShared/modules/dashboard/dashboardActivity/activityCards/ActivityCards';
import ActivityHeader from '@nedoShared/modules/dashboard/dashboardActivity/activityHeader/ActivityHeader';
import styles from './DashboardActivity.module.scss';
const DashboardActivity = ({ fields, values, onChange }) => {
    const filters = $router.searchParams.getAll();
    const [showFilters, setShowFilters] = useState(filters.f || null);
    const handleOpenFilters = () => {
        setShowFilters((x) => {
            const newValue = x ? null : 1;
            $router.searchParams.set('f', newValue);
            return newValue;
        });
    };
    return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx(ActivityHeader, { showFilters: showFilters, setShowFilters: handleOpenFilters, onChange: onChange, filters: filters }), showFilters && _jsx(ActivityFilters, { fields: fields, values: values, onChange: onChange }), _jsx(ActivityCards, { filters: values })] })));
};
export default observer(DashboardActivity);
